var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 51,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C5C5FF",
    fillOpacity: 0.25,
    d: "m21.547 42.862 1.75 6.128c.553 1.934 3.294 1.934 3.847 0l1.75-6.128A20.33 20.33 0 0 1 42.856 28.9l6.136-1.755c1.934-.552 1.934-3.293 0-3.846l-6.131-1.75A20.33 20.33 0 0 1 28.899 7.585L27.144 1.45c-.552-1.934-3.293-1.933-3.845 0l-1.752 6.131A20.33 20.33 0 0 1 7.585 21.544l-6.136 1.754c-1.934.553-1.933 3.293 0 3.846l6.131 1.751a20.33 20.33 0 0 1 13.963 13.963z"
  })));
};
export default SvgStar;